"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[4864],{

/***/ 30687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ QuizEditorialBanner_QuizEditorialBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/compositions/blocks/EditorialBlock/EditorialBlock.tsx + 1 modules
var EditorialBlock = __webpack_require__(74071);
;// CONCATENATED MODULE: ./src/compositions/banners/QuizEditorialBanner/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Build your scent profile with our quiz"
    },
    text: {
        en: "Tell us about the scents you gravitate towards, and we'll find fragrances tailored to fit your tastes."
    },
    buttonTitle: {
        en: "Get started with a quiz"
    },
    seeResults: {
        en: "See your results"
    },
    retakeQuiz: {
        en: "Retake the quiz"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/QuizEditorialBanner/images/bg-mobile.jpg
const bg_mobile_namespaceObject = __webpack_require__.p + "images/bg-mobile_feb8e0.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/QuizEditorialBanner/images/bg-desktop.jpg
const bg_desktop_namespaceObject = __webpack_require__.p + "images/bg-desktop_e51f66.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/QuizEditorialBanner/QuizEditorialBanner.tsx










var bgImage = {
    mobile: bg_mobile_namespaceObject,
    desktop: bg_desktop_namespaceObject
};
var QuizEditorialBanner = function(props) {
    var className = props.className, _props_lazy = props.lazy, lazy = _props_lazy === void 0 ? true : _props_lazy, withScentProfile = props.withScentProfile, withButtonTitleArrow = props.withButtonTitleArrow;
    var primaryLink = withScentProfile ? links/* default */.ZP.scentProfile : links/* default */.ZP.smartRecommendations;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EditorialBlock/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "bg-light-beige"),
        bgImage: bgImage,
        imageLazy: lazy,
        imageFirst: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorialBlock/* default */.Z.BaseContent, {
                title: messages.title,
                text: messages.text,
                buttonProps: {
                    title: withScentProfile ? messages.seeResults : messages.buttonTitle,
                    inlineIcon: withButtonTitleArrow ? "32/arrow-right" : null,
                    to: primaryLink,
                    onClick: function() {
                        (0,analytics/* track */.j)("Banner click", {
                            placement: "Build your scent profile",
                            content: "Quiz",
                            link: primaryLink,
                            action: "link"
                        });
                    },
                    "data-testid": withScentProfile ? "seeResults" : "takeQuiz"
                }
            }),
            withScentProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "mt-16",
                title: messages.retakeQuiz,
                to: links/* default */.ZP.smartRecommendations,
                style: "gold-30-secondary",
                size: 56,
                width: 320,
                fullWidthOnMobile: true,
                onClick: function() {
                    return (0,analytics/* track */.j)("Banner click", {
                        placement: "Build your scent profile",
                        content: "Quiz",
                        link: links/* default */.ZP.smartRecommendations,
                        action: "link"
                    });
                },
                "data-testid": "takeQuiz"
            })
        ]
    });
};
/* harmony default export */ const QuizEditorialBanner_QuizEditorialBanner = (/*#__PURE__*/react.memo(QuizEditorialBanner));


/***/ }),

/***/ 74071:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ EditorialBlock_EditorialBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(39682);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
;// CONCATENATED MODULE: ./src/compositions/blocks/EditorialBlock/components/BaseContent/BaseContent.tsx





var BaseContent = function(props) {
    var supTitle = props.supTitle, title = props.title, titleStyle = props.titleStyle, text = props.text, buttonProps = props.buttonProps;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var baseTitleStyle = isMobile ? "h4" : "h3";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Boolean(supTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-16",
                message: supTitle,
                style: "eye1",
                color: "gold-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title,
                style: titleStyle || baseTitleStyle,
                color: "white",
                html: true
            }),
            Boolean(text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-16",
                message: text,
                style: "p1",
                color: "white"
            }),
            Boolean(buttonProps) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: isMobile ? "mt-16" : "mt-24",
                title: buttonProps.title || messages/* default */.Z.details,
                inlineIcon: buttonProps.inlineIcon,
                to: buttonProps.to,
                style: "gold-30",
                size: 56,
                width: 320,
                fullWidthOnMobile: true,
                onClick: buttonProps.onClick,
                "data-testid": buttonProps["data-testid"]
            })
        ]
    });
};
/* harmony default export */ const BaseContent_BaseContent = (/*#__PURE__*/react.memo(BaseContent));

;// CONCATENATED MODULE: ./src/compositions/blocks/EditorialBlock/EditorialBlock.tsx







var EditorialBlock = function(props) {
    var children = props.children, className = props.className, bgImage = props.bgImage, imageFirst = props.imageFirst, imageLazy = props.imageLazy, dataTestId = props["data-testid"];
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var bgImageSrc = typeof bgImage === "string" ? bgImage : isMobile ? bgImage === null || bgImage === void 0 ? void 0 : bgImage.mobile : bgImage === null || bgImage === void 0 ? void 0 : bgImage.desktop;
    var rootClassName = (0,clsx/* default */.Z)(className, "relative flex", imageFirst ? "flex-col-reverse" : "flex-col");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)(isMobile ? null : "absolute right-0 top-0 z-10 flex h-full max-w-[690rem] items-center"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)("bg-black text-white", isMobile ? "px-40 pb-40 pt-56" : "p-72"),
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                className: "bg-light-beige",
                aspect: isMobile ? 416 / 312 : 1440 / 688,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: bgImageSrc,
                    lazy: imageLazy
                })
            })
        ]
    });
};
EditorialBlock.BaseContent = BaseContent_BaseContent;
/* harmony default export */ const EditorialBlock_EditorialBlock = (EditorialBlock);


/***/ })

}]);